import { adminRoleApi as api } from "./admin-role.api";

export default {
  async getAdminPermissions({ commit }, payload) {
    try {
      commit("GET_ADMIN_PERMISSIONS_LOADING");
      const response = await api.getAdminPermissions(payload);
      commit("GET_ADMIN_PERMISSIONS_SUCCESS", response.data);
      return response;
    } catch (error) {
      commit("GET_ADMIN_PERMISSIONS_ERROR", error.response);
    }
  },
  async getAdminRoles({ commit }, payload) {
    try {
      commit("GET_ADMIN_ROLES_LOADING");
      const response = await api.getAdminRoles(payload);
      commit("GET_ADMIN_ROLES_SUCCESS", response.data);
      return response;
    } catch (error) {
      commit("GET_ADMIN_ROLES_ERROR", error.response);
    }
  },
  async getAdminRole({ commit }, id) {
    try {
      commit("GET_ADMIN_ROLE_LOADING");
      const response = await api.getAdminRole(id);
      commit("GET_ADMIN_ROLE_SUCCESS", response.data);
    } catch (error) {
      commit("GET_ADMIN_ROLE_ERROR", error.response);
    }
  },
  async addAdminRole({ commit }, body) {
    try {
      commit("ADD_ADMIN_ROLE_LOADING");
      const response = await api.addAdminRole(body);
      commit("ADD_ADMIN_ROLE_SUCCESS", response.data);
    } catch (error) {
      commit("ADD_ADMIN_ROLE_ERROR", error.response);
    }
  },
  async updateAdminRole({ commit }, { id, body }) {
    try {
      commit("UPDATE_ADMIN_ROLE_LOADING");
      const response = await api.updateAdminRole(id, body);
      commit("UPDATE_ADMIN_ROLE_SUCCESS", response.data);
    } catch (error) {
      commit("UPDATE_ADMIN_ROLE_ERROR", error.response);
    }
  },
  async deleteAdminRole({ commit }, id) {
    try {
      commit("DELETE_ADMIN_ROLE_LOADING");
      const response = await api.deleteAdminRole(id);
      commit("DELETE_ADMIN_ROLE_SUCCESS", response.data);
    } catch (error) {
      commit("DELETE_ADMIN_ROLE_ERROR", error.response);
    }
  },
};
